module.exports = __webpack_public_path__ + "img/stop.160d70a0.svg";